export const ProductsCollectionModuleName = 'Shop The Collection';